import { render } from "./InformationSection.vue?vue&type=template&id=4da8492c&scoped=true"
import script from "./InformationSection.vue?vue&type=script&lang=js"
export * from "./InformationSection.vue?vue&type=script&lang=js"

import "./InformationSection.vue?vue&type=style&index=0&id=4da8492c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da8492c"]])

export default __exports__